import {
  getFirestore,
  collection,
  doc,
  addDoc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  where,
  // orderBy,
  setDoc,
  onSnapshot,
} from "firebase/firestore";

import { appMobile } from "../config/firebaseConfig";
// import authService from "./authService";

export class FirebaseDbService {
  db;
  constructor() {
    this.db = getFirestore(appMobile);
  }

  // Database service methods

  // Read
  async getAuthDetails(collectionName, uid) {
    try {
      const collectionRef = collection(this.db, collectionName);
      const q = query(collectionRef, where("uid", "==", uid));

      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        return null;
      } else {
        const userDoc = querySnapshot.docs[0];
        return {
          id: userDoc.id,
          ...userDoc.data(),
        };
      }
    } catch (error) {
      console.log("Error in getAdminDetails():", error);
      return false;
    }
  }

  async getAllDocs(collectionName) {
    try {
      const q = query(collection(this.db, collectionName));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
    } catch (error) {
      console.log("Error in getAllDocs:", error);
      return false;
    }
  }

  async getDocsWithQuery(query) {
    try {
      const querySnapshot = await getDocs(query);
      return querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
    } catch (error) {
      console.log("Error in getAllDocs:", error);
      return false;
    }
  }

  async getdocument(collectionName, id) {
    try {
      const docRef = doc(this.db, collectionName, id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        return { ...docSnap.data(), id: docSnap.id };
      } else {
        console.log("Document not found!");
        return false;
      }
    } catch (error) {
      console.log("Error in getDocument():", error);
      return false;
    }
  }

  getLiveDocument(collectionName, id, callback) {
    try {
      const docRef = doc(this.db, collectionName, id);

      // Set up real-time listener
      const unsubscribe = onSnapshot(
        docRef,
        (docSnapshot) => {
          if (docSnapshot.exists()) {
            // Call the callback with the updated document data
            callback({
              ...docSnapshot.data(),
              id: docSnapshot.id,
            });
          } else {
            console.log("Document not found!");
            callback(false);
          }
        },
        (error) => {
          console.log("Error in getLiveDocument():", error);
          callback(false);
        }
      );

      // Return the unsubscribe function so the caller can stop listening when needed
      return unsubscribe;
    } catch (error) {
      console.log("Error in getLiveDocument():", error);
      callback(false);
      return () => { }; // Return empty function in case of error
    }
  }

  // Create
  async createDocument(collectionName, data) {
    try {
      const docRef = await addDoc(collection(this.db, collectionName), data);
      return docRef;
    } catch (error) {
      console.log("Error in createDocumentWithId():", error);
      return false;
    }
  }

  async createDocumentWithId(collectionName, data, id) {
    try {
      await setDoc(doc(this.db, collectionName, id), data);
      return true;
    } catch (error) {
      console.log("Error in createDocumentWithId():", error);
      return false;
    }
  }

  // Update
  async updateDocument(collectionName, data, id) {
    try {
      const docRef = doc(this.db, collectionName, id);
      await updateDoc(docRef, data);
      return docRef;
    } catch (error) {
      console.log("Error in updateDocument():", error);
      return false;
    }
  }

  // Delete
  async deleteDocument(collectionName, id) {
    try {
      const docRef = doc(this.db, collectionName, id);
      await deleteDoc(docRef);
      return true;
    } catch (error) {
      console.log("Error in deleteDoc():", error);
      return false;
    }
  }
}

const dbServiceMobile = new FirebaseDbService();
export default dbServiceMobile;
